export default __webpack_public_path__ + "static/media/bkg--interiors-2.1ed63f70.jpg";